import { render, staticRenderFns } from "./KnModalChangeGroupAll.vue?vue&type=template&id=72968e4b"
import script from "./KnModalChangeGroupAll.js?vue&type=script&lang=js&external"
export * from "./KnModalChangeGroupAll.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports